// ProtectedRoute.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ValuesStore from "../../store/values-store";
import Utilities from "../../dependencies/custom/react-utilities";
const ProtectedRoute = ({ children, allowUnlisted = false }) => {
  const valuesStore = ValuesStore();
  const location = useLocation();
  const navigate = useNavigate();
  const pages = valuesStore?.getValue("pages");

  useEffect(() => {
    const accessToken = Utilities.getCookie("access");
    const refreshToken = Utilities.getCookie("refresh");

    if (!accessToken && !refreshToken) {
      // Not authenticated - redirect to login
      navigate("../../signin", { replace: true, state: { from: location } });
      return;
    }

    // Don't check until pages is defined and non-empty
    if (allowUnlisted || !pages || pages.length === 0) return;

    const isAllowed = pages.some(
      (r) => r?.route?.toLowerCase() === location?.pathname?.toLowerCase(),
    );

    if (!isAllowed) {
      navigate("/403", { replace: true });
    }
  }, [allowUnlisted, pages, location, navigate]);

  return children;
};

export default ProtectedRoute;
